<dynamic-component
  [component]="dynamicComponent"
  (CreatedComponent)="onCreatedComponent($event)"
></dynamic-component>

<div
  class="custom-component--errors nx-margin-top-m"
  *ngIf="control && control.invalid && (control.dirty || control.touched)"
>
  <nx-error *ngFor="let item of (!errorOptions.hideErrorBox && control?.errors) || {} | arrayKeys">
    {{
      (errorOptions.customErrorLabel && errorOptions.customErrorLabel[item]
        ? errorOptions.customErrorLabel[item]
        : 'azForm.errors.' + item
      ) | translate
    }}
  </nx-error>
</div>
